import Product from '@grafikr/shopify-typescript/type/object/Product';
import Variant from '@grafikr/shopify-typescript/type/object/Variant';

import { component } from 'picoapp';
import { getCart } from 'utils/cart';
import Dropdown from 'utils/dropdown';

export default component((node: HTMLElement, ctx) => {
  const data: Product = JSON.parse(node.querySelector('[data-json]').textContent);
  const form: HTMLFormElement = node.querySelector('[data-product-form]');

  /**
   * Custom dropdown
   */

  const dropdowns: NodeListOf<HTMLElement> = node.querySelectorAll('[data-custom-dropdown]');
  dropdowns.forEach((item) => {
    // eslint-disable-next-line no-new
    new Dropdown(item);
  });

  const initOptions = () => {
    const addToCart: HTMLButtonElement = node.querySelector('[data-add-to-cart]');
    const price: HTMLElement = node.querySelector('[data-price]');
    const compareAtPrice: HTMLElement = node.querySelector('[data-compare-price]');

    const callback = (variant: Variant) => {
      if (variant) {
        if (price) price.innerHTML = Shopify.formatMoney(variant.price, theme.moneyFormat);

        if (compareAtPrice) {
          if (variant.compare_at_price > variant.price) {
            compareAtPrice.hidden = false;
            compareAtPrice.innerHTML = Shopify.formatMoney(
              variant.compare_at_price,
              theme.moneyFormat,
            );
          } else {
            compareAtPrice.hidden = true;
          }
        }

        if (variant.available) {
          addToCart.innerHTML = theme.strings.addToCart;
          addToCart.disabled = false;
        } else {
          addToCart.innerHTML = theme.strings.soldOut;
          addToCart.disabled = true;
        }
      } else {
        addToCart.innerHTML = theme.strings.unavailable;
        addToCart.disabled = true;
      }
    };

    const init = () => new Shopify.OptionSelectors(`product-${data.id}`, {
      product: data,
      onVariantSelected: callback,
      enableHistoryState: true,
    });

    const initForm = () => {
      const submit: HTMLButtonElement = form.querySelector('button[type="submit"]');

      const handleChange = (event: Event) => {
        const target = event.target as HTMLInputElement;
        const { optionIndex, index } = target.dataset;

        const select: HTMLSelectElement = node.querySelector(`#product-${data.id}-option-${optionIndex}`);
        select.selectedIndex = Number(index);
        select.dispatchEvent(new Event('change'));
      };

      const handleSubmit = async (event: SubmitEvent) => {
        event.preventDefault();

        submit.textContent = window.theme.strings.states.adding;

        const response = await fetch(`${form.action}.js`, {
          method: form.method,
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: new FormData(form),
        });

        const product = await response.json();

        document.dispatchEvent(new CustomEvent('cart:added', {
          detail: {
            product,
          },
        }));

        submit.textContent = window.theme.strings.addToCart;

        const cartData = await getCart();
        ctx.emit('cart:update', { cart: cartData });
      };

      form.addEventListener('change', handleChange);
      form.addEventListener('submit', handleSubmit);
    };

    if (form) {
      init();
      initForm();
    }
  };

  initOptions();
});
